import { useState } from "react";
import { Button, Input, Label, TextField } from "@heroui/react";

import { usePackageQrDocuments } from "@/features/courier/hooks/use-package-qr-documents.ts";

export const PackageQrDocument = () => {
  const [count, setCount] = useState<number>(100);

  const { mutateAsync, isPending } = usePackageQrDocuments();

  return (
    <div className="flex flex-col gap-4 p-4">
      <p className="text-neutral-600 font-medium">QRы для пакетов</p>

      <TextField>
        <Label>Кол-вол</Label>
        <Input
          className="bg-white"
          defaultValue="1"
          disabled={isPending}
          max={500}
          type="number"
          value={`${count}`}
          onChange={(e) => setCount(Number(e.target.value))}
        />
      </TextField>

      <Button
        className="mt-auto"
        isPending={isPending}
        onPress={() => mutateAsync({ count })}
      >
        Распечатать
      </Button>
    </div>
  );
};
